import { useCatalogRouteMatch, useSearchParams } from '@utils/common';
import { SeoCatalogBlocks } from '@components/catalog/SeoCatalogBlocks';
import { useIndexedFilters } from '@hook/productFilters';

import { useSeoCatalogBlocksInfoQuery } from './graphql.v3.generated';

const ALSO_SEARCH_TAGS_COUNT = 20;

interface Props {
  className?: string,
}

export const SeoCatalogBlocksContainer: React.FC<Props> = ({
  className,
}) => {
  const {
    activeFilters: activeIndexedFilters,
    hasFilters: hasIndexedFilters,
  } = useIndexedFilters();
  const [{ page }] = useSearchParams();
  const match = useCatalogRouteMatch();
  const params = match?.params;

  let slug;
  let citySlug;
  if (params) {
    slug = 'slug' in params ? params.slug : params.namespace;
    citySlug = 'city' in params ? params.city : undefined;
  }

  const { data } = useSeoCatalogBlocksInfoQuery({
    variables: {
      citySlug,
      slug: slug || params?.namespace || '',
      alsoSearchCrossLinkingFirst: ALSO_SEARCH_TAGS_COUNT,
      alsoSearchCrossLinkingOffset: (+(page || 1) - 1) * ALSO_SEARCH_TAGS_COUNT,
      indexedFilters: hasIndexedFilters ? {
        characteristicChoiceId: activeIndexedFilters?.characteristics?.length
          ? activeIndexedFilters.characteristics[0]
          : undefined,
        color: activeIndexedFilters?.colors?.length
          ? activeIndexedFilters.colors[0]
          : undefined,
        brandId: activeIndexedFilters?.brands?.length
          ? activeIndexedFilters.brands[0]
          : undefined,
      } : undefined,
      skipIndexedFiltersBlocks: hasIndexedFilters || !!citySlug,
    },
    skip: !(slug || params?.namespace),
  });

  const catalog = data?.catalog;
  return (
    <SeoCatalogBlocks
      className={className}
      alsoSearchTags={catalog?.alsoSearchCrossLinking || []}
      siblings={catalog?.siblings || []}
      seoDescription={catalog?.seoDescription}
      tagGroupCrossLinking={catalog?.tagGroupCrossLinking || []}
      citySlug={citySlug}
    />
  );
};
